import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../component/helpers/EventEmitter';
import masterService from './services/Common/MasterService';

class Connector {
  constructor() {
    var me = this;
    me.ready = false;

    window.addEventListener('message', function(e) {
      if (e.data.type === 'fiinInit') {
        me.messagePort = e.ports[0];
        me.messagePort.onmessage = function(e) {
          me.onMessage(e, me);
        };
        me.ready = true;
      }
    });

    me.subscriptions = [];
    me.callbacks = [];
  }

  onMessage(e, me) {
    var message = e.data;
    switch (message.type) {
      case 'request':
        if (me.callbacks[message.envelop]) {
          for (var cb of me.callbacks[message.envelop]) {
            cb(message);
          }
          delete me.callbacks[message.envelop];
        }
        break;
      case 'subscribe':
        if (me.subscriptions[message.envelop]) {
          for (var cb of me.subscriptions[message.envelop]) {
            cb(message.message);
          }
        }
        break;
      case 'changeCode':
        var code = message.code;
        var type = message.dataType;
        switch (type) {
          case 'STOCK':
            masterService.getListOrganization().then(data => {
              let organ = data.items.find(el => el.ticker === code);
              organ.isDerivatives = false;
              organ.code = organ.organCode;
              EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
                syncType: 'TYPE_BLUE',
                search: organ,
                componentId: 1,
              });
            });
            break;
          case 'DERIVATIVE':
            masterService.getAllDerivatives().then(data => {
              let deri = data.items.find(el => el.derivativeCode === code);
              deri.isDerivatives = true;
              deri.displayCode = deri.organCode;
              deri.code = deri.derivativeCode;
              EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
                syncType: 'TYPE_BLUE',
                search: deri,
                componentId: 1,
              });
            });
            break;
          case 'CW':
            masterService.getAllCoveredWarrants().then(data => {
              let cw = data.items.find(el => el.coveredWarrantCode === code);
              cw.code = cw.coveredWarrantCode;
              EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
                syncType: 'TYPE_BLUE',
                search: cw,
                componentId: 1,
              });
            });
            break;
          case 'INDEX':
            masterService.getAllCompanyGroup().then(data => {
              var index = data.items.find(el => el.comGroupCode === code);
              index.isDerivatives = false;
              index.code = index.comGroupCode;
              index.organCode = index.comGroupCode;
              index.isIndex = true;
              EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
                syncType: 'TYPE_BLUE',
                search: index,
                componentId: 1,
              });
            });
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
  }

  get(url, callback) {
    var me = this;
    if (!me.ready) {
      setTimeout(() => {
        me.get(url, callback);
      }, 100);
    } else {
      me.internalGet(url, callback);
    }
  }

  internalGet(url, callback) {
    this.messagePort.postMessage({ type: 'get', url });
    if (!this.callbacks[url]) {
      this.callbacks[url] = [];
    }
    this.callbacks[url].push(callback);
  }

  post(url, data, type, callback) {
    var me = this;
    if (!me.ready) {
      setTimeout(() => {
        me.post(url, data, type, callback);
      }, 100);
    } else {
      this.internalPost(url, data, type, callback);
    }
  }

  internalPost(url, data, type, callback) {
    this.messagePort.postMessage({ type: 'post', data: { url, data, type } });
    if (!this.callbacks[url]) {
      this.callbacks[url] = [];
    }
    this.callbacks[url].push(callback);
  }

  subscribe(channel, callback) {
    var me = this;
    if (!me.ready) {
      setTimeout(() => {
        me.subscribe(channel, callback);
      }, 100);
    } else {
      me.internalSubscribe(channel, callback);
    }
  }

  internalSubscribe(channel, callback) {
    this.messagePort.postMessage({ type: 'subscribe', channel });
    if (!this.subscriptions[channel]) {
      this.subscriptions[channel] = [];
    }
    this.subscriptions[channel].push(callback);
  }

  unsubscribe(channel) {
    this.messagePort.postMessage({ type: 'unsubscribe', channel });
    delete this.subscriptions[channel];
  }
}

const connector = new Connector();

export default connector;
